import React, { useEffect, useState } from "react";
import { arit, site } from "../config/api";

import {
  HiOutlineAcademicCap,
  HiOutlineBanknotes,
  HiOutlineBars3,
  HiOutlineBookOpen,
  HiOutlineBriefcase,
  HiOutlineBuildingLibrary,
  HiOutlineCalendarDays,
  HiOutlineChevronDown,
  HiOutlineClipboardDocumentCheck,
  HiOutlineHeart,
  HiOutlineHome,
  HiOutlineMagnifyingGlassCircle,
  HiOutlineMap,
  HiOutlineMoon,
  HiOutlinePencilSquare,
  HiOutlinePhone,
  HiOutlineShieldCheck,
  HiOutlineUserGroup,
  HiOutlineXMark,
} from "react-icons/hi2";
import { FaFacebook } from "react-icons/fa";
import Background from "../assets/images/bg_page.png";
import { academicYearFullLabel } from "../config/academicYear";
import "./Headers.css";

const base = process.env.REACT_APP_BASENAME || "";

const staffLinks = [
  {
    href: site + "/administrator-system/",
    label: "สำหรับผู้ดูแลระบบ | อาจารย์แนะแนว | คณะ",
    Icon: HiOutlineShieldCheck,
  },
  {
    href: site + "/onlinescore/#/",
    label: "กรอกคะแนนสอบสัมภาษณ์ (คณะกรรมการ)",
    Icon: HiOutlinePencilSquare,
  },
  {
    href: site + "/nurse_interviwe2022/",
    label: "กรอกคะแนนสอบสัมภาษณ์ (คณะพยาบาลศาสตร์)",
    Icon: HiOutlineHeart,
  },
];

const registerItems = [
  {
    href: `${base}/Register/1`,
    label: "ปริญญาตรี ภาคปกติ (จันทร์-ศุกร์)",
    Icon: HiOutlineBookOpen,
  },
  {
    href: `${base}/Register/2`,
    label: "ปริญญาตรี ภาค กศ.บป. (เสาร์-อาทิตย์)",
    Icon: HiOutlineMoon,
  },
  {
    href: `${base}/select-bundit`,
    label: "ระดับบัณฑิตศึกษา (โท-เอก)",
    Icon: HiOutlineUserGroup,
  },
  {
    href: `${base}/Register/5`,
    label: "ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู",
    Icon: HiOutlineBriefcase,
  },
];

const curriculumItems = [
  {
    href: "https://reg.kpru.ac.th/ad_kpru/pages/adcur_kpru1.asp",
    label: "ระดับปริญญาตรี",
    Icon: HiOutlineBookOpen,
  },
  {
    href: "https://reg.kpru.ac.th/ad_kpru/pages/adcur_kpru2.asp",
    label: "ระดับปริญญาโท - เอก",
    Icon: HiOutlineAcademicCap,
  },
  {
    href: "https://reg.kpru.ac.th/ad_kpru/pages/adcur_kpru3.asp",
    label: "ระดับประกาศนียบัตร",
    Icon: HiOutlineBriefcase,
  },
];

const facultyItems = [
  { href: "https://edu.kpru.ac.th/", label: "คณะครุศาสตร์", Icon: HiOutlineAcademicCap },
  {
    href: "https://huso.kpru.ac.th/main/",
    label: "คณะมนุษยศาสตร์และสังคมศาสตร์",
    Icon: HiOutlineBookOpen,
  },
  {
    href: "https://scitech.kpru.ac.th/",
    label: "คณะวิทยาศาสตร์และเทคโนโลยี",
    Icon: HiOutlineCalendarDays,
  },
  { href: "https://fms.kpru.ac.th/", label: "คณะวิทยาการจัดการ", Icon: HiOutlineBriefcase },
  {
    href: "https://techno.kpru.ac.th/techno/",
    label: "คณะเทคโนโลยีอุตสาหกรรม",
    Icon: HiOutlineBuildingLibrary,
  },
  { href: "https://nurse.kpru.ac.th/", label: "คณะพยาบาลศาสตร์", Icon: HiOutlineHeart },
  {
    href: "https://maesot.kpru.ac.th/th/",
    label: "มหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด",
    Icon: HiOutlineMap,
  },
  {
    href: "http://graduates.kpru.ac.th/",
    label: "บัณฑิตวิทยาลัย",
    Icon: HiOutlineUserGroup,
  },
];

function MenuIcon({ Icon, size = 16 }) {
  if (!Icon) return null;
  return (
    <span className="sh-ico" aria-hidden="true">
      <Icon size={size} />
    </span>
  );
}

function DropMenu({ id, label, Icon, items, openId, setOpenId }) {
  const open = openId === id;
  return (
    <li className={open ? "is-open" : ""}>
      <button
        type="button"
        className="site-header__drop-btn"
        aria-expanded={open}
        onClick={() => setOpenId(open ? null : id)}
      >
        <MenuIcon Icon={Icon} />
        {label}
        <span className="site-header__caret" aria-hidden="true">
          <HiOutlineChevronDown size={14} />
        </span>
      </button>
      <ul className="site-header__dropdown">
        {items.map((item) => (
          <li key={item.href}>
            <a
              href={item.href}
              {...(item.href.startsWith("http")
                ? { target: "_blank", rel: "noreferrer" }
                : {})}
            >
              <MenuIcon Icon={item.Icon} size={15} />
              <span>{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </li>
  );
}

function Headers() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 992) {
        setMenuOpen(false);
        setOpenId(null);
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header className="site-header">
      <div className="site-header__top">
        <div className="site-header__top-inner">
          <a className="site-header__brand" href={`${base}/`}>
            <MenuIcon Icon={HiOutlineAcademicCap} size={18} />
            ระบบรับสมัครนักศึกษา
          </a>
          <div className="site-header__staff">
            {staffLinks.map(({ href, label, Icon }) => (
              <a key={href} href={href} target="_blank" rel="noreferrer">
                <MenuIcon Icon={Icon} size={14} />
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <nav className="site-header__nav" aria-label="เมนูหลัก">
        <div className="site-header__nav-inner">
          <button
            type="button"
            className="site-header__toggle"
            aria-expanded={menuOpen}
            aria-controls="site-header-menu"
            onClick={() => {
              setMenuOpen((v) => !v);
              setOpenId(null);
            }}
          >
            <MenuIcon Icon={menuOpen ? HiOutlineXMark : HiOutlineBars3} size={18} />
            {menuOpen ? "ปิดเมนู" : "เมนู"}
          </button>
          <ul
            id="site-header-menu"
            className={`site-header__menu${menuOpen ? " is-open" : ""}`}
          >
            <li>
              <a href={`${base}/`}>
                <MenuIcon Icon={HiOutlineHome} />
                หน้าแรก
              </a>
            </li>
            <DropMenu
              id="register"
              label="สมัครเรียนออนไลน์"
              Icon={HiOutlineAcademicCap}
              items={registerItems}
              openId={openId}
              setOpenId={setOpenId}
            />
            <li>
              <a href={`${base}/Checkregister/2`}>
                <MenuIcon Icon={HiOutlineMagnifyingGlassCircle} />
                ตรวจสอบสถานะ
              </a>
            </li>
            <li>
              <a href={`${base}/Tuitionfee`}>
                <MenuIcon Icon={HiOutlineBanknotes} />
                ค่าธรรมเนียมการศึกษา
              </a>
            </li>
            <li>
              <a href={`${base}/Checkpresent`}>
                <MenuIcon Icon={HiOutlineClipboardDocumentCheck} />
                กรอกข้อมูลรายงานตัว
              </a>
            </li>
            <DropMenu
              id="curriculum"
              label="หลักสูตรเรียนอะไร/จบแล้วทำอะไร"
              Icon={HiOutlineBookOpen}
              items={curriculumItems}
              openId={openId}
              setOpenId={setOpenId}
            />
            <DropMenu
              id="faculty"
              label="เยี่ยมชมคณะ"
              Icon={HiOutlineBuildingLibrary}
              items={facultyItems}
              openId={openId}
              setOpenId={setOpenId}
            />
            <li>
              <a
                href={arit + "/page_id/406/TH"}
                target="_blank"
                rel="noreferrer"
              >
                <MenuIcon Icon={HiOutlineMap} />
                แผนผังมหาวิทยาลัยราชภัฏกำแพงเพชร
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div
        className="site-header__hero"
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className="site-header__hero-inner">
          <h1>มหาวิทยาลัยราชภัฏกำแพงเพชร</h1>
          <p>
            เปิดรับสมัครนักศึกษาใหม่ <strong>{academicYearFullLabel()}</strong>
          </p>
          <ul className="site-header__contacts">
            <li>
              <MenuIcon Icon={HiOutlinePhone} size={14} />
              <span>
                ภาคปกติ - ภาค กศ.บป. · (055) 706 547 ·{" "}
                <a
                  href="https://www.facebook.com/kpru.register"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebook size={12} aria-hidden /> Facebook
                </a>
              </span>
            </li>
            <li>
              <MenuIcon Icon={HiOutlinePhone} size={14} />
              <span>
                ปริญญาโท - ปริญญาเอก · (055) 706 555 ต่อ 1770, 1780 ·{" "}
                <a
                  href="https://www.facebook.com/graduateskpru/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebook size={12} aria-hidden /> Facebook
                </a>
              </span>
            </li>
            <li>
              <MenuIcon Icon={HiOutlinePhone} size={14} />
              <span>
                ประกาศนียบัตรบัณฑิต · (055) 706 555 ต่อ 2010 ·{" "}
                <a href="https://www.facebook.com/edukpru/" target="_blank" rel="noreferrer">
                  <FaFacebook size={12} aria-hidden /> Facebook
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Headers;
